'use client';
import FetchProvider from '@blueshift-ui/fetch/dist/components/fetch-provider';
import useGraphqlClient from '@blueshift-ui/fetch/dist/hooks/use-graphql-client';
import { PropsWithChildren } from 'react';

export function GraphQLProvider({ children }: PropsWithChildren<unknown>) {
  const client = useGraphqlClient();
  return <FetchProvider client={client}>{children}</FetchProvider>;
}
